import React from 'react';
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Box,
    Divider,
} from '@mui/material';
import {
    Dashboard,
    Campaign,
    Schedule,
    AccountCircle,
    Message,
    Analytics,
    Description,
    CalendarToday,
    History,
    Payment,
    AdminPanelSettings,
    Logout,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';

const drawerWidth = 240;

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);

    const menuItems = [
        { text: 'لوحة التحكم', icon: <Dashboard />, path: '/dashboard' },
        { text: 'الحملات', icon: <Campaign />, path: '/campaigns' },
        { text: 'المنشورات المجدولة', icon: <Schedule />, path: '/scheduled' },
        { text: 'الحسابات', icon: <AccountCircle />, path: '/accounts' },
        { text: 'الشات بوت', icon: <Message />, path: '/chatbot' },
        { text: 'التحليلات', icon: <Analytics />, path: '/analytics' },
        { text: 'المسودات', icon: <Description />, path: '/drafts' },
        { text: 'التقويم', icon: <CalendarToday />, path: '/calendar' },
        { text: 'القوالب', icon: <Description />, path: '/templates' },
        { text: 'سجل النشاطات', icon: <History />, path: '/activity-logs' },
    ];

    const bottomItems = [
        { text: 'الفواتير', icon: <Payment />, path: '/billing' },
    ];

    // Admin specific items
    const adminItems = [
        { text: 'لوحة الإدارة', icon: <AdminPanelSettings />, path: '/admin' },
        { text: 'طلبات الدفع', icon: <Payment />, path: '/admin/payments' },
    ];

    return (
        <Drawer
            variant="permanent"
            anchor="right"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    mt: 8,
                    borderLeft: 1,
                    borderColor: 'divider',
                },
            }}
            dir="rtl"
        >
            <Box sx={{ overflow: 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <List sx={{ px: 1, pt: 2 }}>
                    {(user?.isAdmin ? [...adminItems, ...menuItems] : menuItems).map((item) => (
                        <ListItem key={item.path} disablePadding sx={{ mb: 0.5 }}>
                            <ListItemButton
                                onClick={() => navigate(item.path)}
                                selected={location.pathname === item.path}
                                sx={{
                                    borderRadius: 2,
                                    '&.Mui-selected': {
                                        bgcolor: 'primary.light',
                                        color: 'primary.main',
                                        '& .MuiListItemIcon-root': {
                                            color: 'primary.main',
                                        },
                                    },
                                    '&:hover': {
                                        bgcolor: 'action.hover',
                                    },
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 40 }}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.text}
                                    primaryTypographyProps={{ fontSize: '0.875rem' }}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>

                <Box sx={{ mt: 'auto' }}>
                    <Divider sx={{ my: 1 }} />
                    <List sx={{ px: 1 }}>
                        {/* Show Billing only for normal users */}
                        {!user?.isAdmin && bottomItems.map((item) => (
                            <ListItem key={item.path} disablePadding sx={{ mb: 0.5 }}>
                                <ListItemButton
                                    onClick={() => navigate(item.path)}
                                    selected={location.pathname === item.path}
                                    sx={{
                                        borderRadius: 2,
                                        '&.Mui-selected': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.main',
                                            '& .MuiListItemIcon-root': {
                                                color: 'primary.main',
                                            },
                                        },
                                    }}
                                >
                                    <ListItemIcon sx={{ minWidth: 40 }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{ fontSize: '0.875rem' }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <ListItem disablePadding sx={{ mb: 0.5 }}>
                            <ListItemButton
                                onClick={() => {
                                    dispatch(logout());
                                    navigate('/login');
                                }}
                                sx={{
                                    borderRadius: 2,
                                    color: 'error.main',
                                    '&:hover': {
                                        bgcolor: 'error.lighter',
                                        backgroundColor: 'rgba(211, 47, 47, 0.04)'
                                    },
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 40, color: 'error.main' }}>
                                    <Logout />
                                </ListItemIcon>
                                <ListItemText
                                    primary="تسجيل الخروج"
                                    primaryTypographyProps={{ fontSize: '0.875rem' }}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Box>
        </Drawer>
    );
};

export default Sidebar;
